import { IClientEmailGroupResponse } from '@common/interfaces/clientEmailGroup'
import { combineReducers } from 'redux'
import { createLoadingDataReducer } from '../../helpers/redux'
import { ILoadingData } from '../types'
import {
  DELETE_CLIENT_EMAIL_GROUP_REQUEST,
  GET_CLIENT_EMAIL_GROUP_REQUEST,
  PROVISION_CLIENT_EMAIL_GROUP_REQUEST,
} from './actions'

export interface IClientEmailGroupsState {
  emailGroup: ILoadingData<IClientEmailGroupResponse>
}

export default combineReducers({
  emailGroup: createLoadingDataReducer<IClientEmailGroupResponse>(
    [GET_CLIENT_EMAIL_GROUP_REQUEST],
    [PROVISION_CLIENT_EMAIL_GROUP_REQUEST, DELETE_CLIENT_EMAIL_GROUP_REQUEST],
  ),
})
